import { getPlanId } from '../util/urls.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { persistReducer } from '../../common/redux/persistence';

export const getPlanPrefixedKey = (key: string) => {
	const planId = getPlanId() || 'none';
	return `jpo-app-simple-plans-${planId}-${key}`;
};
